// Module
var code = "<span class=\"light\" ng-show=\"$ctrl.answer\" ng-i18next=\"[i18next]({answer:$ctrl.answer})assignments.editScanByQuestion.answer\">";
// Exports
module.exports = code;